module.exports = function getResource(label, vars = []) {
    let resources = {
        viewSimilarProductsText: 'View similar products',
        writeReviewText: 'Write A Review',
        moreColor: 'more color',
        moreColors: 'more colors',
        itemShip: 'This item cannot be shipped to',
        canada: ' Canada',
        us: ' the United States',
        color: 'Color: '
    };

    return resources[label];
};
